import { useTranslation } from "react-i18next";
import styles from "./VideoDetailsSection.module.css";
import { useVideoDetailsSection } from "./useVideoDetailsSection";
import {
  RemoveVideoButton,
  VideoFileUpload,
  VideoPreview,
  VideoTextField,
  VideoThumbnailField,
} from "./VideoDetailsFields";

/**
 * One video tutorial editor row: title, description, file, preview, and thumbnail second.
 * Remove is shown only when the parent allows deleting this row.
 */
const VideoDetailsSection = ({
  video,
  index,
  onVideoChange,
  onRemove,
  showRemoveButton,
  onVideoRef,
}) => {
  const { t } = useTranslation();
  const {
    fileInputId,
    handleDescriptionChange,
    handleDragLeave,
    handleDragOver,
    handleDrop,
    handleFileChange,
    handleFileClick,
    handleLoadedMetadata,
    handleNameChange,
    handleThumbnailSecondBlur,
    handleThumbnailSecondChange,
    isDragging,
    selectedUploadFile,
    videoDuration,
    videoPreview,
    videoRef,
  } = useVideoDetailsSection({ video, index, onVideoChange, onVideoRef });

  return (
    <div className={styles.videoDetailsSection}>
      {showRemoveButton && (
        <RemoveVideoButton
          onRemove={onRemove}
          label={t("components.videoTutorialSectionModal.removeVideo")}
        />
      )}

      <div className={styles.videoInputs}>
        <VideoTextField
          label={t("components.videoTutorialSectionModal.videoTitle")}
          placeholder={t(
            "components.videoTutorialSectionModal.videoTitlePlaceholder",
          )}
          value={video?.name || ""}
          onChange={handleNameChange}
        />
        <VideoTextField
          label={t("components.videoTutorialSectionModal.videoDescription")}
          placeholder={t(
            "components.videoTutorialSectionModal.videoDescriptionPlaceholder",
          )}
          value={video?.description || ""}
          onChange={handleDescriptionChange}
        />
      </div>

      <div className={styles.videoUploadRow}>
        <VideoFileUpload
          file={selectedUploadFile}
          isDragging={isDragging}
          onFileChange={handleFileChange}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          onClick={handleFileClick}
          fileInputId={fileInputId}
        />
        <VideoPreview
          videoRef={videoRef}
          videoPreview={videoPreview}
          onLoadedMetadata={handleLoadedMetadata}
          placeholder={t(
            "components.videoTutorialSectionModal.thumbnailPreview",
          )}
        />
        <VideoThumbnailField
          label={t("components.videoTutorialSectionModal.thumbnailSecond")}
          placeholder={t(
            "components.videoTutorialSectionModal.thumbnailSecondPlaceholder",
          )}
          value={video?.thumbnailSecond}
          onChange={handleThumbnailSecondChange}
          onBlur={handleThumbnailSecondBlur}
          duration={videoDuration}
        />
      </div>
    </div>
  );
};

export default VideoDetailsSection;
